import { SubUser, UserAdminConfig, PermissionContainer } from "../../../../data/model"
import Auth0SubUserEditor from "./Auth0SubUserEditor"
import DefaultSubUserEditor from "./DefaultSubUserEditor"

export type SubUserEditorProps = {
    subUser?: SubUser
    headline: number
    permissionContainer?: PermissionContainer
    userAdminConfig: UserAdminConfig
    type: "edit" | "create"
    onclose(reload: boolean): void
}

type Props = SubUserEditorProps & {
    subUserVersion: "default" | "auth0"
}

export default function SubUserEditor(props: Props) {
    const { subUserVersion, ...rest } = props
    const isAuth0SubUserVersion = subUserVersion === "auth0"

    if (isAuth0SubUserVersion) {
        return <Auth0SubUserEditor {...rest} />
    }
    return <DefaultSubUserEditor {...rest} />
}
